import dialogPolyfill from 'dialog-polyfill';

export class FenêtreSurgissante extends HTMLElement {

    // Pas de circonflexe pour Firefox...
    static nom = "fenetre-surgissante";

    static Événements = Object.freeze({
       "FENÊTRE_SURGISSANTE_FERMETURE": "FenêtreSurgissante-fermeture"
    });

    // static observedAttributes = ["colonneId"];
    shadowRoot;
    champs = {};

    constructor() {
        super();

        // https://developer.mozilla.org/en-US/docs/Web/API/Web_components/Using_templates_and_slots
        let template = document.querySelector("#fenêtreSurgissante");
        let templateContent = template.content;

        // this.shadowRoot = this.attachShadow({mode: "open"});
        this.shadowRoot = this; // <-- Ne pas créer de Shadow DOM : pour polyfill iOS 12
        // this.shadowRoot.appendChild(templateContent.cloneNode(true));
        this.appendChild(templateContent.cloneNode(true)); // Attacher directement
        this.dialogÉlément = this.shadowRoot.querySelector("#dialogue");
        // Enregistre le dialogue avec le polyfill !
        dialogPolyfill.registerDialog(this.dialogÉlément);

        this.texte = this.shadowRoot.querySelector("#texte");

        this.texteÉditable = this.shadowRoot.querySelector("#texteÉditable");
        this.texteÉditableLabel = this.shadowRoot.querySelector("#texteÉditableLabel");
        this.texteÉditable.addEventListener("keydown", (e) => {
            // Pour permettre la soumission/enregistrement sur la touche ENTER
            if (e.key === 'Enter') {
                e.preventDefault();
                e.stopPropagation();
                this.shadowRoot.querySelector("#okAction").click();
            }
        })

        this.dialogÉlément.addEventListener("close", (e) => {
            this.ferme(e);
        })

        // Intercepte le comportement standard de submit pour récupérer la valeur du champs d'édition
        this.shadowRoot.querySelector("#formDialog").addEventListener("submit", (e) => {
            this.champs["texteÉditable"] = this.texteÉditable.value;
        })

    }

    ferme() {
        this.style.display = "none";

        this.dispatchEvent(new CustomEvent(FenêtreSurgissante.Événements.FENÊTRE_SURGISSANTE_FERMETURE, {
            detail: {
                "confirmation" : this.dialogÉlément.returnValue,
                "champs" : this.champs,
            },
            bubbles: true,
            composed: true
        }))
    }

    édite(texte, label) {

        this.dialogÉlément.removeAttribute("class");
        this.dialogÉlément.classList.add("édition");
        this.setOkTexte("Enregistrer");

        this.texte.style.display = "none";

        this.texteÉditableLabel.innerText = label;
        this.texteÉditableLabel.style.display = "block";

        this.texteÉditable.value = texte;
        this.texteÉditable.style.display = "block";

        this.style.display = "block";

        this.shadowRoot.querySelector("#annulerAction").style.display = "block";

        this.afficheModal();
    }

    informe(texte){

        this.dialogÉlément.removeAttribute("class");
        this.dialogÉlément.classList.add("confirmation");
        this.setOkTexte("OK");

        this.afficheTexte(texte);
    }

    avertis(texte) {
        this.dialogÉlément.removeAttribute("class");
        this.dialogÉlément.classList.add("avertissement");
        this.setOkTexte("OK");

        this.afficheTexte(texte);
    }

    afficheTexte(texte) {
        this.setTexte(texte);

        this.texteÉditable.style.display = "none";
        this.texteÉditableLabel.style.display = "none";
        this.style.display = "block";

        this.shadowRoot.querySelector("#annulerAction").style.display = "none";

        this.afficheModal();
    }

    confirme(texte){

        this.setTexte(texte);
        this.setOkTexte("OK");

        this.texteÉditable.style.display = "none";
        this.texteÉditableLabel.style.display = "none";
        this.style.display = "block";

        this.shadowRoot.querySelector("#annulerAction").style.display = "block";
        this.afficheModal();
    }

    afficheModal() {
        if (!this.dialogÉlément.open) {
            this.dialogÉlément.showModal();
        }
    }

    setTexte(texte) {
        this.texte.innerHTML = texte;
        this.texte.style.display = "block";
    }

    setOkTexte(okTexte) {
        this.shadowRoot.querySelector("#okAction").innerText = okTexte;
    }

    setAnnulerTexte(annulerText) {
        this.shadowRoot.querySelector("#annulerAction").innerText = annulerText;
    }


    connectedCallback() {
        this.okText = this.getAttribute("okText");
        this.annulerText = this.getAttribute("annulerText");
        // C'est ici que le DOM pourrait être construit si pas template
        // Idem pour style (inline ou link)

    }

    disconnectedCallback() {
        // console.log("Custom element removed from page.");
    }

    adoptedCallback() {
        // console.log("Custom element moved to new page.");
    }

    attributeChangedCallback(name, oldValue, newValue) {
    }

}
